<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>

    <Sheet.Body class="pt-[15px] pb-[calc(env(safe-area-inset-bottom)+16px)]!">
      <h2 class="text-[26px] leading-[30px] font-medium text-gray-800">
        Proof of infringement report
        <br />
        with
        <DacrAIIcon
          class="inline-block h-[22px] w-auto align-[-2px]"
          aria-label="Dacr AI"
        />
      </h2>

      <p class="mt-5 text-[15px] leading-[22px] text-gray-500">
        DIIS powered by Dacr AI identifies every point of similarity between
        your work and the suspected infringement. Court-admissible evidence.
      </p>

      <a
        href="/diis"
        target="_blank"
        class="text-link mt-1.5 inline-block text-[15px] leading-[22px]"
      >
        Learn more
      </a>

      <div class="-mx-4 mt-6 overflow-hidden">
        <img
          :src="InfringementImage"
          class="relative left-1/2 block w-[130%] max-w-none -translate-x-1/2"
          alt=""
        />
      </div>

      <div class="flex flex-col border-t border-gray-900/10 pt-[21px]">
        <div class="text-[14px] leading-[18px] font-medium text-gray-400">
          Comparison analysis report
        </div>
        <div class="mt-2 text-[34px] leading-[38px] font-medium text-gray-800">
          {{ reportPrice }}
        </div>
        <Button
          variant="primary"
          size="lg"
          class="mt-5"
          @click="handleGetReport"
        >
          Get report
        </Button>
      </div>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Button, useSheet } from '@dacr/library'
import { CloseIcon, DacrAIIcon } from '@dacr/icons'

import InfringementImage from '@/assets/images/Infringement.png'
import { useInfringementReport } from '../useInfringementReport'
import { formatPrice } from '@/shared/utils/money'
import { computed } from 'vue'

const { close } = useSheet()
const { handleGetReport } = useInfringementReport()
const reportPrice = computed(() =>
  formatPrice({ amount: 20, hideDecimals: true })
)
</script>
